import React from "react";
import { useRouteLoaderData } from "react-router-dom";
import TabLayout from "../../helpers/TabLayout";
import { Stack } from "@mui/material";
import EditableField from "../helpers/EditableField";
import LabeledEntry from "../../helpers/LabeledEntry";
import {
  sessionUpdate,
  sessionUpdateShortDescription,
} from "../../../api/session";
import EditButtons from "../helpers/EditButtons";
import useEditObject from "../../../hooks/useEditObject";

const GeneralTab = () => {
  const loaderData = useRouteLoaderData("profileComponent");
  const userEntity = loaderData.userEntityRes?.data;
  const shortDescription = loaderData.shortDescriptionRes?.data;
  const {
    editObject,
    isEditable,
    startEdit,
    stopEdit,
    editHandler: handleFieldChange,
  } = useEditObject();

  const handleSave = async (event) => {
    event.preventDefault();
    const response = await sessionUpdate({
      ...userEntity,
      ...editObject.current,
    });
    if (response.code === "SUCCESS") {
      loaderData.userEntityRes.data = { ...userEntity, ...editObject.current };
      if (editObject.current.shortDescription !== undefined) {
        await sessionUpdateShortDescription(
          editObject.current.shortDescription);
        loaderData.shortDescriptionRes.data = editObject.current.shortDescription;
      }
      if (editObject.current.firstName !== undefined) {
        window.location.reload();
      }
      stopEdit();
    }
  };

  return (
    <TabLayout
      headerLabel="General"
      skeletonLines={15}
    >
      <Stack
        component="form"
        onSubmit={handleSave}
        method="POST"
        height="100%"
        justifyContent="space-between"
      >
        <Stack spacing={4}>
          <EditableField
            label="First Name"
            type="text"
            id="firstName"
            name="firstName"
            initialValue={userEntity?.firstName}
            placeholder="John"
            required={false}
            isEditable={isEditable}
            onChange={handleFieldChange}
          />
          <EditableField
            label="Last Name"
            type="text"
            id="lastName"
            name="lastName"
            initialValue={userEntity?.lastName}
            placeholder="Doe"
            required={false}
            isEditable={isEditable}
            onChange={handleFieldChange}
          />
          <LabeledEntry
            label="Primary Email"
            value={userEntity?.email}
          />
          <EditableField
            label="Phone Number"
            type="text"
            id="phone"
            name="phone"
            initialValue={userEntity?.phone}
            placeholder="XXX-XXX-XXXX"
            required={false}
            isEditable={isEditable}
            onChange={handleFieldChange}
          />
          <EditableField
            label="Short Description"
            type="text"
            id="shortDescription"
            name="shortDescription"
            initialValue={shortDescription}
            placeholder={
              `My name is ${userEntity?.firstName &&
              userEntity.firstName?.length
                ? userEntity?.firstName
                : "John"}${userEntity?.lastName &&
              ` ${userEntity?.lastName}`}👋, and I enjoy....`}
            required={false}
            isEditable={isEditable}
            onChange={handleFieldChange}
            multiline
            rows={3}
            variant="outlined"
          />
        </Stack>
        <EditButtons
          isEditable={isEditable}
          onUpdateClicked={startEdit}
          onSaveClicked={handleSave}
          onCancelClicked={stopEdit}
        />
      </Stack>
    </TabLayout>
  );
};

export default GeneralTab;